module.exports = __webpack_public_path__ + "images/about-us-8d415799ea1bf23ef5e0276e1ac02c91.jpg";